import {
    AVAILABLE_TICKET_STATUS,
    ON_SALE,
} from '../../containers/ticketSelection/constants';
import { TicketStatus } from '../../models/tickets';
import { CheckoutState } from '../../state';
import { getIsAppRebrandActive } from '../app/getIsAppRebrandActive';
import { getTicketsById } from './pureSelectors';

export const areQuantitySelectorsHidden = (state: CheckoutState): boolean => {
    const ffEnableHiding = state.app.featureFlags?.checkoutUniversalFlag;
    if (!ffEnableHiding) {
        return false;
    }

    const ticketsById = getTicketsById(state);
    const allTickets = Object.values(ticketsById);

    if (allTickets.length === 0) {
        return false;
    }

    const ticketsWithVisibleSelectors = allTickets.filter((ticket) => {
        const hasTicketOptionsRange =
            ticket.ticketOptionsRange && ticket.ticketOptionsRange.length > 0;

        if (hasTicketOptionsRange) {
            return (
                ticket.onSaleStatus === ON_SALE ||
                ticket.onSaleStatus === AVAILABLE_TICKET_STATUS
            );
        }

        const ticketStatus = ticket.statusKey as TicketStatus;
        if (!ticketStatus) {
            return false;
        }

        const STATUSES_WITH_VISIBLE_SELECTORS = [
            TicketStatus.onSale,
            TicketStatus.salesEndSoon,
        ];

        if (STATUSES_WITH_VISIBLE_SELECTORS.includes(ticketStatus)) {
            return true;
        }

        if (ticketStatus === TicketStatus.soldOut) {
            return !getIsAppRebrandActive(state);
        }

        const STATUSES_WITH_HIDDEN_SELECTORS = [
            TicketStatus.salesEnded,
            TicketStatus.salesStartAfter,
            TicketStatus.unavailable,
            TicketStatus.salesNotStarted,
            TicketStatus.salesStartSoon,
        ];

        return !STATUSES_WITH_HIDDEN_SELECTORS.includes(ticketStatus);
    });

    return ticketsWithVisibleSelectors.length === 0;
};
